import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import styled from 'styled-components';
import './App.css';
import bars from './img/bars.svg';
import { initApplication } from './components/init/initActions';
import AppRouter from './router/AppRouter';

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

if (process.env.REACT_APP_STAGE === 'prod') {
  ReactGA.initialize('UA-130132855-3');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

function App({ dispatchInitApplication, loading, isLoggingIn }) {
  useEffect(() => {
    dispatchInitApplication();
  }, [dispatchInitApplication, isLoggingIn]);
  return (
    <div>
      {loading ? (
        <LoaderContainer>
          <img alt="loader" src={bars} width="150" />
        </LoaderContainer>
      ) : (
        <AppRouter />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  loading: state.init.loading,
  isLoggingIn: state.init.isLoggingIn
});

const mapDispatchToProps = dispatch => ({
  dispatchInitApplication: () => dispatch(initApplication())
});

App.propTypes = {
  dispatchInitApplication: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isLoggingIn: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
